import { c as _c } from "react/compiler-runtime";
import PureHtml from "../custom/PureHtml";
export default function TextSection(t0) {
  const $ = _c(10);
  const {
    atext
  } = t0;
  const t1 = atext?.heading;
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="border-l-primary border-l-3 ps-2 text-xl lg:text-2xl">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = atext?.subheading;
  let t4;
  if ($[2] !== t3) {
    t4 = <h3 className="text-base lg:text-xl">{t3}</h3>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = atext?.subtext;
  let t6;
  if ($[4] !== t5) {
    t6 = <PureHtml html={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t6) {
    t7 = <section className="py-2"><div className="max-w-7xl mx-auto px-2"><div className="grid grid-cols-1 gap-3 lg:gap-4"><div className="bg-white p-3 rounded shadow-md">{t2}{t4}{t6}</div></div></div></section>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}